'use client';

import { MenuKey, PrefixHint } from './primitives';

export type MenuFooterText = {
  productsPrefix: string;
  threadsPrefix: string;
  commandsPrefix: string;
  navigate: string;
  select: string;
  backToAll: string;
};

export function MenuFooter({
  text,
  atRoot,
  onPrefix,
  onBack,
}: {
  text: MenuFooterText;
  atRoot: boolean;
  onPrefix: (prefix: string) => void;
  onBack: () => void;
}) {
  return (
    <div className="border-border/40 text-muted-foreground flex h-10 shrink-0 items-center justify-between gap-3 border-t px-4 text-xs">
      <div className="flex min-w-0 items-center gap-3">
        {atRoot ? (
          <>
            <PrefixHint
              prefix="#"
              label={text.productsPrefix}
              onActivate={onPrefix}
            />
            <PrefixHint
              prefix="@"
              label={text.threadsPrefix}
              onActivate={onPrefix}
            />
            <PrefixHint
              prefix=">"
              label={text.commandsPrefix}
              onActivate={onPrefix}
            />
          </>
        ) : (
          <button
            type="button"
            tabIndex={-1}
            onMouseDown={(event) => {
              // Keep focus in the command input while popping the page.
              event.preventDefault();
              onBack();
            }}
            className="text-muted-foreground hover:text-foreground inline-flex items-center gap-1.5 text-xs transition-colors"
          >
            <MenuKey className="pointer-events-auto cursor-pointer">⌫</MenuKey>
            <span>{text.backToAll}</span>
          </button>
        )}
      </div>
      {/* Keyboard hints don't apply on touch-first devices. */}
      <div
        aria-hidden="true"
        className="hidden shrink-0 items-center gap-3 whitespace-nowrap sm:flex [@media(pointer:coarse)]:hidden"
      >
        <span className="inline-flex items-center gap-1.5">
          <span className="inline-flex items-center gap-0.5">
            <MenuKey>↑</MenuKey>
            <MenuKey>↓</MenuKey>
          </span>
          <span>{text.navigate}</span>
        </span>
        <span className="inline-flex items-center gap-1.5">
          <MenuKey>↵</MenuKey>
          <span>{text.select}</span>
        </span>
      </div>
    </div>
  );
}
